"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["size", "width", "height", "fill"];

var _default = function _default(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? size : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? size : _ref$height,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#808080' : _ref$fill,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    width: size,
    height: size,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, restProps), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6289 2.29279C11.8165 2.10532 12.0708 2 12.3359 2C12.6011 2 12.8554 2.10532 13.0429 2.29279L17.0429 6.29279C17.2251 6.48139 17.3259 6.73399 17.3236 6.99619C17.3213 7.25838 17.2162 7.5092 17.0308 7.6946C16.8453 7.88001 16.5945 7.98518 16.3323 7.98746C16.0701 7.98974 15.8175 7.88894 15.6289 7.70679L13.3359 5.41379V14.9998C13.3359 15.265 13.2306 15.5194 13.043 15.7069C12.8555 15.8944 12.6012 15.9998 12.3359 15.9998C12.0707 15.9998 11.8164 15.8944 11.6288 15.7069C11.4413 15.5194 11.3359 15.265 11.3359 14.9998V5.41379L9.04294 7.70679C8.85434 7.88894 8.60173 7.98974 8.33954 7.98746C8.07734 7.98518 7.82653 7.88001 7.64112 7.6946C7.45571 7.5092 7.35054 7.25838 7.34826 6.99619C7.34598 6.73399 7.44678 6.48139 7.62894 6.29279L11.6289 2.29279ZM5.33594 12.9998C5.33594 12.2041 5.65201 11.4411 6.21462 10.8785C6.77723 10.3159 7.54029 9.99979 8.33594 9.99979H9.33594C9.60115 9.99979 9.85551 10.1051 10.043 10.2927C10.2306 10.4802 10.3359 10.7346 10.3359 10.9998C10.3359 11.265 10.2306 11.5194 10.043 11.7069C9.85551 11.8944 9.60115 11.9998 9.33594 11.9998H8.33594C8.07072 11.9998 7.81637 12.1051 7.62883 12.2927C7.44129 12.4802 7.33594 12.7346 7.33594 12.9998V18.9998C7.33594 19.265 7.44129 19.5194 7.62883 19.7069C7.81637 19.8944 8.07072 19.9998 8.33594 19.9998H16.3359C16.6012 19.9998 16.8555 19.8944 17.043 19.7069C17.2306 19.5194 17.3359 19.265 17.3359 18.9998V12.9998C17.3359 12.7346 17.2306 12.4802 17.043 12.2927C16.8555 12.1051 16.6012 11.9998 16.3359 11.9998H15.3359C15.0707 11.9998 14.8164 11.8944 14.6288 11.7069C14.4413 11.5194 14.3359 11.265 14.3359 10.9998C14.3359 10.7346 14.4413 10.4802 14.6288 10.2927C14.8164 10.1051 15.0707 9.99979 15.3359 9.99979H16.3359C17.1316 9.99979 17.8946 10.3159 18.4573 10.8785C19.0199 11.4411 19.3359 12.2041 19.3359 12.9998V18.9998C19.3359 19.7954 19.0199 20.5585 18.4573 21.1211C17.8946 21.6837 17.1316 21.9998 16.3359 21.9998H8.33594C7.54029 21.9998 6.77723 21.6837 6.21462 21.1211C5.65201 20.5585 5.33594 19.7954 5.33594 18.9998V12.9998Z",
    fill: fill
  }));
};

exports["default"] = _default;